import { Link } from '../../lib/router';
import { Page, PageHeader } from '../../components/layout';
import { LEGAL } from './legalInfo';
import styles from './legal.module.css';

const Mail = () => <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>;

export function TermsPage() {
  return (
    <Page>
      <PageHeader title="Voorwaarden" />
      <article className={styles.doc}>
        <p className={styles.meta}>Algemene voorwaarden van BlackBlack · geldig vanaf {LEGAL.effectiveDate}</p>

        <h2>1. Wie wij zijn</h2>
        <p>
          BlackBlack (blackblack.app) is een platform voor korte video's en muziek, aangeboden door <strong>{LEGAL.company}</strong>, ingeschreven bij de KvK onder nummer {LEGAL.kvk}{LEGAL.address && `, gevestigd op ${LEGAL.address}`}. Contact: <Mail />.
        </p>
        <p>Door een account te maken of BlackBlack te gebruiken ga je akkoord met deze voorwaarden en met ons <Link to="/privacy">privacybeleid</Link>.</p>

        <h2>2. Je account</h2>
        <ul>
          <li>Je moet minimaal {LEGAL.minimumAge} jaar oud zijn om een account te maken.</li>
          <li>Je geeft juiste gegevens op en houdt je wachtwoord geheim. Je bent verantwoordelijk voor wat er met je account gebeurt.</li>
          <li>Eén persoon per account. Je mag je account niet verkopen of overdragen.</li>
          <li>Je kunt je account op elk moment laten verwijderen via <Mail />.</li>
        </ul>

        <h2>3. Jouw content</h2>
        <p>Je blijft eigenaar van de video's, muziek, afbeeldingen en teksten die je plaatst. Je geeft BlackBlack een niet-exclusieve, kosteloze, wereldwijde licentie om je content op te slaan, te bewerken voor weergave (zoals omzetten naar andere formaten en thumbnails maken), te tonen en te verspreiden binnen BlackBlack, zolang je content online staat.</p>
        <p>Je plaatst alleen content waarvoor je de rechten hebt. Upload <strong>alleen muziek die je zelf hebt gemaakt</strong> of waarvoor je aantoonbaar toestemming hebt, of gebruik geluiden uit de BlackBlack-bibliotheek.</p>

        <h2>4. Wat niet mag</h2>
        <ul>
          <li>Content die illegaal is of inbreuk maakt op rechten van anderen (zoals auteursrecht of portretrecht).</li>
          <li>Haat, intimidatie, bedreiging, geweld verheerlijken, of content die zelfbeschadiging aanmoedigt.</li>
          <li>Seksuele content, en in het bijzonder alles waarin minderjarigen betrokken zijn.</li>
          <li>Spam, misleiding, nepaccounts, of het manipuleren van likes, volgers of steun.</li>
          <li>BlackBlack verstoren, beveiliging omzeilen of het platform geautomatiseerd uitlezen zonder toestemming.</li>
        </ul>

        <h2>5. Melden en verwijderen</h2>
        <p>Iedereen kan content of accounts melden via de knop <em>Rapporteren</em>, of per e-mail aan <Mail /> (bijvoorbeeld voor een auteursrechtclaim). Vermeld waar het om gaat en waarom het volgens jou niet mag. We beoordelen meldingen zorgvuldig en zo snel mogelijk.</p>
        <p>We kunnen content verwijderen of verbergen en accounts tijdelijk of permanent blokkeren als ze deze voorwaarden of de wet schenden. Je krijgt daarvan bericht met de reden, behalve als de wet dat verbiedt. Ben je het er niet mee eens, dan kun je bezwaar maken via <Mail />; we bekijken je bezwaar opnieuw.</p>

        <h2>6. Creator Pro</h2>
        <ul>
          <li>Creator Pro is een betaald maandabonnement met extra functies, zoals grotere uploads, een Pro-badge en een lagere platformfee op fan-steun. De actuele prijs zie je voordat je betaalt; prijzen zijn inclusief btw.</li>
          <li>Het abonnement wordt elke maand automatisch verlengd en betaald via Stripe. Je kunt op elk moment opzeggen via <em>Instellingen → Creator Pro &amp; fan-steun</em>; je houdt Pro tot het einde van de lopende maand. Betaalde maanden worden niet terugbetaald.</li>
          <li><strong>Herroepingsrecht:</strong> je hebt als consument 14 dagen bedenktijd. Omdat Pro direct na betaling start, vragen we je bij het afrekenen om hiermee in te stemmen; je herroepingsrecht vervalt dan voor de periode waarin je Pro al hebt gebruikt.</li>
          <li>We kunnen de prijs of inhoud van Pro wijzigen. Een prijsverhoging melden we minimaal 30 dagen vooraf; je kunt dan opzeggen voordat de nieuwe prijs ingaat.</li>
        </ul>

        <h2>7. Fan-steun</h2>
        <ul>
          <li>Makers kunnen fans de mogelijkheid geven hen maandelijks te steunen. Het bedrag kiest de maker. Steun is een vrijwillige bijdrage: je krijgt er geen product of recht op extra content voor, tenzij de maker dat zelf belooft.</li>
          <li>Betalingen lopen via Stripe. Om steun te ontvangen moet een maker een uitbetaalaccount bij Stripe aanmaken en de voorwaarden van Stripe accepteren (Stripe Connected Account Agreement). Stripe controleert de identiteit van makers.</li>
          <li>BlackBlack houdt een platformfee in van {LEGAL.platformFee} van elke betaling ({LEGAL.proPlatformFee} voor makers met Creator Pro). Stripe rekent daarnaast eigen transactiekosten. De rest wordt door Stripe aan de maker uitbetaald.</li>
          <li>Makers zijn zelf verantwoordelijk voor de belasting over wat ze ontvangen.</li>
          <li>Fans kunnen steun op elk moment opzeggen; de steun stopt aan het einde van de lopende maand.</li>
          <li>We kunnen steun weigeren of terugdraaien bij fraude, misbruik of schending van deze voorwaarden.</li>
        </ul>

        <h2>8. Beschikbaarheid en aansprakelijkheid</h2>
        <p>We doen ons best om BlackBlack goed en veilig te laten werken, maar kunnen niet beloven dat het altijd foutloos of zonder onderbreking beschikbaar is. We zijn niet aansprakelijk voor content van gebruikers. Onze aansprakelijkheid is beperkt tot het bedrag dat je ons in de 12 maanden vóór de schade hebt betaald, behalve bij opzet of grove nalatigheid. Je wettelijke rechten als consument blijven altijd gelden.</p>

        <h2>9. Wijzigingen</h2>
        <p>We kunnen deze voorwaarden aanpassen. Belangrijke wijzigingen melden we minimaal 30 dagen vooraf in de app. Als je BlackBlack daarna blijft gebruiken, gelden de nieuwe voorwaarden. Ben je het er niet mee eens, dan kun je je account verwijderen.</p>

        <h2>10. Recht en geschillen</h2>
        <p>Op deze voorwaarden is Nederlands recht van toepassing. Heb je een klacht, neem dan eerst contact op via <Mail />; we reageren binnen 14 dagen. Komen we er samen niet uit, dan kun je naar de bevoegde rechter in Nederland.</p>
      </article>
    </Page>
  );
}

export function PrivacyPage() {
  return (
    <Page>
      <PageHeader title="Privacy" />
      <article className={styles.doc}>
        <p className={styles.meta}>Privacybeleid van BlackBlack · geldig vanaf {LEGAL.effectiveDate}</p>

        <h2>1. Wie is verantwoordelijk</h2>
        <p>
          <strong>{LEGAL.company}</strong> (KvK {LEGAL.kvk}{LEGAL.address && `, ${LEGAL.address}`}) is verwerkingsverantwoordelijke voor de persoonsgegevens op BlackBlack. Vragen of verzoeken: <Mail />.
        </p>

        <h2>2. Welke gegevens we verwerken</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Gegevens</th>
              <th>Waarvoor</th>
              <th>Grondslag</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Account: gebruikersnaam, naam, e-mailadres, wachtwoord (versleuteld opgeslagen), profielfoto, bio</td>
              <td>Je account aanmaken en beveiligen, inloggen</td>
              <td>Overeenkomst</td>
            </tr>
            <tr>
              <td>Content: video's, muziek, afbeeldingen, reacties, playlists</td>
              <td>Je content opslaan en tonen aan anderen</td>
              <td>Overeenkomst</td>
            </tr>
            <tr>
              <td>Activiteit: wie je volgt, likes, bekeken video's en kijkduur, zoekopdrachten</td>
              <td>Je feed en aanbevelingen samenstellen, statistieken voor makers, het platform verbeteren</td>
              <td>Gerechtvaardigd belang</td>
            </tr>
            <tr>
              <td>Technisch: IP-adres, browser/apparaat, inlogsessies</td>
              <td>Beveiliging, misbruik en spam tegengaan, foutopsporing</td>
              <td>Gerechtvaardigd belang</td>
            </tr>
            <tr>
              <td>Meldingen en moderatie: meldingen die je doet of over je worden gedaan, genomen maatregelen</td>
              <td>Regels handhaven en wettelijke verplichtingen</td>
              <td>Wettelijke plicht / gerechtvaardigd belang</td>
            </tr>
            <tr>
              <td>Betalingen: Pro-abonnement, steun die je geeft of ontvangt, bedragen en status</td>
              <td>Betalingen afhandelen, uitbetalen aan makers, administratie</td>
              <td>Overeenkomst / wettelijke plicht (bewaarplicht)</td>
            </tr>
          </tbody>
        </table>
        <p>
          <strong>Je betaalgegevens</strong> (kaart, IBAN) en, voor makers, je identiteitsgegevens voor uitbetalingen worden rechtstreeks door <strong>Stripe</strong> verwerkt. Wij krijgen die niet te zien; we bewaren alleen een verwijzing naar je Stripe-klant of -account en de status van je abonnementen.
        </p>

        <h2>3. Wat anderen zien</h2>
        <p>Je gebruikersnaam, naam, profielfoto, bio, openbare video's, openbare playlists, reacties en aantallen (volgers, likes, supporters) zijn voor iedereen zichtbaar. Je e-mailadres en betaalgegevens zijn nooit openbaar. Of je een maker steunt, ziet alleen jij en die maker.</p>

        <h2>4. Met wie we gegevens delen</h2>
        <p>We verkopen je gegevens niet. We gebruiken deze dienstverleners (verwerkers), met wie afspraken over beveiliging en geheimhouding gelden:</p>
        <ul>
          <li><strong>Railway</strong> – hosting van de app (servers in Nederland; Railway is een Amerikaans bedrijf).</li>
          <li><strong>Supabase</strong> – database (servers in Ierland).</li>
          <li><strong>Cloudflare</strong> – opslag en levering van media, DNS en beveiliging.</li>
          <li><strong>Stripe</strong> – betalingen en uitbetalingen. Stripe is voor een deel van de verwerking zelf verantwoordelijke (zie het privacybeleid van Stripe).</li>
        </ul>
        <p>Waar gegevens buiten de Europese Economische Ruimte terechtkomen (bijvoorbeeld bij Amerikaanse bedrijven), gebeurt dat op basis van het EU-VS Data Privacy Framework of de standaardcontractbepalingen van de Europese Commissie.</p>
        <p>We delen gegevens met politie of andere instanties alleen als de wet ons daartoe verplicht.</p>

        <h2>5. Hoe lang we gegevens bewaren</h2>
        <ul>
          <li>Account en content: zolang je account bestaat. Na verwijdering wissen we je gegevens binnen 30 dagen, behalve wat we wettelijk moeten bewaren.</li>
          <li>Activiteitsgegevens: maximaal 2 jaar.</li>
          <li>Inlogsessies: maximaal 30 dagen na je laatste gebruik.</li>
          <li>Betaalgegevens en facturen: 7 jaar (fiscale bewaarplicht).</li>
          <li>Moderatie- en meldgegevens: zolang nodig voor de handhaving, maximaal 2 jaar na afhandeling.</li>
        </ul>

        <h2>6. Cookies</h2>
        <p>BlackBlack gebruikt alleen een <strong>functionele cookie</strong> om je ingelogd te houden. We gebruiken geen tracking- of advertentiecookies en tonen daarom geen cookiemelding. Bij betalen kan Stripe op zijn eigen pagina's cookies plaatsen voor fraudepreventie.</p>

        <h2>7. Je rechten</h2>
        <p>Je hebt het recht op inzage, correctie, verwijdering, beperking en overdracht van je gegevens, en je kunt bezwaar maken tegen verwerking op basis van gerechtvaardigd belang. Stuur je verzoek naar <Mail />; we reageren binnen een maand. Je profiel kun je ook zelf aanpassen in de app.</p>
        <p>Ben je het niet eens met hoe we met je gegevens omgaan, dan kun je een klacht indienen bij de <a href="https://autoriteitpersoonsgegevens.nl" target="_blank" rel="noreferrer">Autoriteit Persoonsgegevens</a>.</p>

        <h2>8. Beveiliging</h2>
        <p>We beveiligen je gegevens met onder meer versleutelde verbindingen (HTTPS), versleutelde wachtwoorden, beperkte toegang tot de database en controle van geüploade bestanden. Ontdek je een beveiligingsprobleem? Meld het via <Mail />.</p>

        <h2>9. Minderjarigen</h2>
        <p>BlackBlack is bedoeld voor mensen van {LEGAL.minimumAge} jaar en ouder. Merken we dat een account van iemand jonger is, dan verwijderen we het.</p>

        <h2>10. Wijzigingen</h2>
        <p>We kunnen dit privacybeleid aanpassen. Belangrijke wijzigingen melden we in de app. Zie ook onze <Link to="/voorwaarden">voorwaarden</Link>.</p>
      </article>
    </Page>
  );
}
